import { ICustomCellRendererParams } from "@ts/common-types";
import moment from 'moment';

const ParseDateCellRenderer = (params: ICustomCellRendererParams) => {
    return (
        <>
            {params.node.rowPinned ? null : (
                <div>
                    {
                        params.data[params.column.colId] &&
                        moment(params.data[params.column.colId]).format('YYYY-MM-DD HH:mm:ss')
                    }
                </div>
            )}
        </>
    );
}

export default ParseDateCellRenderer;